import React from "react"
import { Box, Dialog, Progress } from "@carrotfertility/carotene-core"
import { DialogCloseButton } from "@carrotfertility/carotene-core-x"
import { WhichEmailStep } from "#/components/telemedicine/pediatrics/WhichEmailStep"
import { LeavingCarrotStep } from "#/components/telemedicine/pediatrics/LeavingCarrotStep"
import { ErrorDialog } from "#/components/telemedicine/pediatrics/ErrorDialog"
import {
  AccessBlueberryAccountDialogStep,
  useAccessBlueberryAccountDialog,
  UseAccessBlueberryAccountDialogState
} from "#/components/telemedicine/pediatrics/hooks/useAccessBlueberryAccountDialog"

export interface AccessBlueberryAccountDialogProps {
  open: boolean
  onClose: () => void
}

function AccessBlueberryAccountFlowStep({
  continueUrl,
  isCreatingEligibility,
  isLoading,
  isError,
  step,
  email,
  goToLeavingCarrot,
  closeAndReset
}: UseAccessBlueberryAccountDialogState): JSX.Element {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: (theme) => theme.spacing(theme.tokens.spacing.xl)
        }}
      >
        <Progress />
      </Box>
    )
  }

  if (isError || step === AccessBlueberryAccountDialogStep.ERROR) {
    return <ErrorDialog onClose={closeAndReset} />
  }

  if (step === AccessBlueberryAccountDialogStep.WHICH_EMAIL) {
    return <WhichEmailStep email={email} onContinue={goToLeavingCarrot} />
  }

  return (
    <LeavingCarrotStep
      continueUrl={continueUrl}
      isCreatingEligibility={isCreatingEligibility}
      onClose={closeAndReset}
    />
  )
}

export function AccessBlueberryAccountDialog({ open, onClose }: AccessBlueberryAccountDialogProps): JSX.Element {
  const accessBlueberryAccountDialogState = useAccessBlueberryAccountDialog(onClose, open)

  return (
    <Dialog open={open} onClose={accessBlueberryAccountDialogState.closeAndReset}>
      <DialogCloseButton onClick={accessBlueberryAccountDialogState.closeAndReset} />
      <AccessBlueberryAccountFlowStep {...accessBlueberryAccountDialogState} />
    </Dialog>
  )
}
